module.exports = __webpack_public_path__ + "static/media/alarm_old.dcbfe7ab.mp3";